import { INTEGRATION_VENDORS } from "@/const/vendors-constants"
import { ConfigurationPageTemplate } from "@/pages/IntegrationsPage/components/templates/ConfigurationPageTemplate"
import { GcrConfigurationTab } from "./GcrConfigurationTab"

export const GcrConfigurationPage = () => {
  const vendor = INTEGRATION_VENDORS.gcr

  return (
    <ConfigurationPageTemplate
      vendor={vendor}
      config={<GcrConfigurationTab vendor={vendor} />}
      titleKey="integrations.configuration.gcr.configurationTitle"
    />
  )
}
